import { Button, Text } from '@nike/eds'
import { type RootState, useAppSelector } from 'api/redux'
import { UnitDetailsPanel } from 'components/left-detail-panel'
import { MainPanel } from 'components/main-panel'
import { Reprint } from 'components/reprint'
import { useTranslation } from 'react-i18next'
import { LabelType, type Unit } from 'types'
import { checkIfLabelIsEnabled } from 'utils/printconfig'
import { type ApiHandlerContext } from 'utils/useApiHandler'

interface CgradeCompletionProps {
  unitData: Unit
  handleReturn: () => void
  updateUnitCgradeCompleteContext: ApiHandlerContext<Unit>
  printLabelContext: ApiHandlerContext<LabelType>
}

export const CgradeCompletion = ({ unitData, handleReturn, updateUnitCgradeCompleteContext, printLabelContext }: CgradeCompletionProps) => {
  const { t } = useTranslation()

  const completeUnit = () => {
    updateUnitCgradeCompleteContext.handleApiCall({
      ...unitData,
      status: 'HANDLED'
    }).then()
  }

  const printConfig = useAppSelector((state: RootState) => state.application.printConfig)

  const getCgradeTitle = () => {
    return checkIfLabelIsEnabled(printConfig, LabelType.CGrade)
      ? t('c_grade_completion.label_enabled_text')
      : t('c_grade_completion.label_disabled_text')
  }
  const mainPanelContent =
    <div className='flex flex-col flex-grow justify-between'>
      <Text font={'title-1'} as={'h1'}>{getCgradeTitle()}</Text>
      <div className="flex justify-between w-100 mt-20">
        <Button className='text-2xl' onClick={handleReturn} variant='secondary'>
          {t('buttons.return')}
        </Button>
        <Button className='text-2xl' onClick={completeUnit}>
          {t('buttons.complete_unit') + (unitData.quantity > 1 ? 's' : '')}
        </Button>
      </div>
    </div>

  return <MainPanel
    leftPanelContent={<UnitDetailsPanel unit={unitData} showImage={true} />}
    mainPanelContent={mainPanelContent}
    rightPanelContent={<Reprint unit={unitData} printLabelContext={printLabelContext}/>}
  />
}
